 $('document').ready(function() {


window.onload = function() {
    var element = document.querySelector('.product-recommendations--loaded .cstm-rlated');
    if (element) {
        element.classList.add('active');
    }
};

setTimeout(function() {
    var btn = document.querySelector(".related-products__heading");
    var slide1 = document.querySelector(".cstm-rlated");
    var btn2 = document.querySelector(".recent-view-heading");
    var slide2 = document.querySelector("#shopify-section-template--22403899916563__product_recommend_sec_bzMDmc");

    // Ensure slide1 is active initially
    if (slide1) {
        slide1.classList.add('active');
    }

    btn.addEventListener("click", function() {
        if (slide1) {
            slide1.classList.add("active"); 
        }
        if (slide2) {
            slide2.classList.remove("active");
        }
    });

    btn2.addEventListener("click", function() {
        if (slide2) {
            slide2.classList.add("active"); 
        }
        if (slide1) {
            slide1.classList.remove("active");
        }
    });

}, 4000);





document.querySelectorAll('.mbl-btn').forEach(function(button, index) {
    button.addEventListener('click', function(e) {
        // Select the corresponding desktop button by index
        const correspondingDesktopBtn = document.querySelectorAll('.desktop-btn')[index];
        if (correspondingDesktopBtn) {
            correspondingDesktopBtn.click();
        }
    });
});


   
            setTimeout(function() {
                document.querySelectorAll('.quick-add-button.desktop-btn').forEach(function(button) {
                    button.addEventListener('click', function(event) {
                        var productId = event.target.getAttribute('data-product-id');
                        addToCart(productId);
                    });
                });
            }, 2500);

            function addToCart(productId) {
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        id: productId,
                        quantity: 1
                    })
                })
                .then(response => response.json())
                .then(data => {
                    console.log('Product added to cart:', data);
                    fetch(`${routes.cart_url}?section_id=cart-drawer`)
                        .then((response) => response.text())
                        .then((responseText) => {
                            const html = new DOMParser().parseFromString(responseText, "text/html");
                            const selectors = ["cart-drawer", ".cart-drawer__footer"];
                            for (const selector of selectors) {
                                const targetElement = document.querySelector(selector);
                                const sourceElement = html.querySelector(selector);
                                if (targetElement && sourceElement) {
                                    targetElement.replaceWith(sourceElement);
                                }
                            }
                            document.querySelector('cart-drawer').open();
                        })
                        .catch((e) => {
                            console.error(e);
                        });
                })
                .catch(error => {
                    console.error('Error adding product to cart:', error);
                });
            }

        });